import {getBackendHost} from "./js/url.helper.js";

window.MODE = import.meta.env.MODE;
console.log('mode', window.MODE, 'env', process.env.NODE_ENV);

window.EXTERNAL_MODULE_HOST = location.protocol + '//' + location.host + '/ott'; // Where to find external modules such as ott-ui-booking
if (window.MODE !== 'production') {
    window.EXTERNAL_MODULE_HOST = 'http://localhost:5173';
}
window.contextPath = getBackendHost();

function getOttResourcesPath() {
    return window.contextPath + '/ott-api/api/resources/ottResources';
}

window.document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
window.snapToRoadsApiKey = 'AIzaSyC9T3K27kGLDaahxJisrOCHra_ulvmyvs4';
window.mapAssetsUrl = 'js/dist/map-assets.js';
window.urls = {
    overview: 'app/pages/overview.html',
    signin: 'app/pages/signin.html',
    'account-activation': 'app/pages/account-activation.html',
    'reset-password': 'app/pages/reset-password.html',
    'forgot-password': 'app/pages/forgot-password.html',
    'business-management': 'app/pages/business-management.html',
    'vehicle-administration': 'app/pages/vehicle-administration.html',
    'user-management': 'app/pages/user-management.html',
    'customer-management': 'app/pages/customer-management.html',
    'user-settings': 'app/pages/user-settings.html',
    'route-planner': 'app/pages/route-planner.html',
    'vehicle-schedule': 'app/pages/vehicle-schedule.html',
    'booking': 'app/pages/booking.html',
    'release-notes': 'app/pages/release-notes.html',
    'monitor': 'app/pages/monitor.html',
    'ottResources': getOttResourcesPath(),
    'filters-json': 'json/filters.json',
    'pages-json': 'json/pages.json',
    'translate-json': 'json/translate.json',
    'car-list-directive': 'app/directive/car-list-directive.html',
    'trip-list-directive': 'app/directive/trip-list-directive.html',
    'trip-list-route-directive': 'app/directive/trip-list-route-directive.html',
    'special-customer': 'app/pages/special-customer.html',
    'map': 'app/pages/map.html',
    'admin': 'app/pages/admin.html',
    'zoneadmin': 'app/pages/zone-admin.html'
};

var version = Date.now();
window.resolveUrl = function(tplName) {
    var u = window.urls[tplName];
    if (u) {
        if (u.indexOf('.json') > -1) {
            return u;
        }
        return u + '?version=' + version;
    }
    return 'notFound';
};

window.addEventListener('storage', (e) => {
    if (['BnrAccessToken', 'BnrRefreshToken'].indexOf(e.key) > -1) {
        console.log('storage key, new value set, event source url', e.key, !!e.newValue, e.url && e.url.split('?')[0]);
    }
});

window._bnrSentrySnapshot = function(name) {
    if (typeof Sentry !== 'undefined') {
        Sentry.configureScope(function(scope) {
            scope.setTag('name', name);
            scope.setTag('BnrProfileData', JSON.parse(localStorage.getItem('BnrProfileData') || '{}'));
            scope.setTag('BnrAccessTokenSet', !!localStorage.getItem('BnrAccessToken'));
            scope.setTag('BnrRefreshTokenSet', !!localStorage.getItem('BnrRefreshToken'));
        });
        Sentry.captureException(new Error("BNR Sentry Snapshot"));
    }
}

window.addEventListener('load', function() {
    function isBrowserNotSupported() {
        if (!window.console || !window.console.error) {
            return 'Console not supported';
        }
        if (!window.Promise) {
            return 'Promises not supported';
        }
        if (!window.Intl || !window.Intl.Collator) {
            return 'Intl.Collator not supported';
        }
        if (!window.Map) {
            return 'Map not supported';
        }
        if (!Function.prototype.bind) {
            return 'Function.prototype.bind not supported';
        }
        if (!Array.prototype.findIndex) {
            return 'Array.prototype.findIndex not supported';
        }
        if (!Array.prototype.find) {
            return 'Array.prototype.find not supported';
        }
        return '';
    }

    function checkBrowserPrerequisities() {
        var notSupported = isBrowserNotSupported();
        if (notSupported) {
            window.document.documentElement.className += ' not-supported';
            window.document.querySelector('#noscript').innerHTML = notSupported + ' - please use a modern browser';
            return false;
        }
        return true;
    }

    window.ottUiRelease = __APP_VERSION__;

    if (!checkBrowserPrerequisities()) {
        return;
    }

    // var files = [window.resolveUrl('ottResources'), 'js/all-assets.js', '//browser.sentry-cdn.com/4.0.6/bundle.min.js'];
    var sentryUrl = ['//browser.sentry-cdn.com/5.6.1/bundle.min.js'];
    // if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.1') > -1) {
    //     files.unshift('js/DBugger.js');
    // }

    var test = (function() {
        var qs = location.hash.split('?');
        if (qs.length === 2) {
            qs = decodeURIComponent(qs[1]).split('&');
            var params = new Map();
            for (var i = 0, l = qs.length; i < l; i++) {
                var arr = qs[i].split('=', 2);
                params.set(arr[0], arr.length === 2 ? arr[1] : null);
            }
            return params.has('test');
        }
        return false;
    })();

    // Load sentry separately so a failed sentry call doesn't block everything else
    new DSerialLoader().require(sentryUrl).then(function() {
        Sentry.init({
            // dsn: 'https://769c5f54be78465fbd0f00cc83202436@sentry.io/1278710',
            dsn: 'https://a560961dee5e4ffa9542b09e98f9e2ca@o477858.ingest.sentry.io/5519475',
            release: window.ottUiRelease ? window.ottUiRelease : '',
            captureUnhandledRejections: false,
            tracesSampleRate: 0.1
        });
    });

    fetch(window.resolveUrl('pages-json'))
        .then((response) => response.json())
        .then(pagesResponse => {
            window.PAGES = pagesResponse;

            new DSerialLoader().require([window.resolveUrl('ottResources')]).then(function() {
                var files = [
                    window.mapApiUrl
                ];
                if (test) {
                    files.push('js/test-app-assets.js');
                }

                new DSerialLoader(files, {typeValue: 'module'}).require().then(function() {
                    // Load special customer module after app-assets to ensure inheritance works

                    const appModule = import.meta.glob('./js/index-app.js');
                    appModule['./js/index-app.js']().then((res) => console.log('module result', res));

                    var splash = window.document.getElementById('splash');
                    splash.parentNode.removeChild(splash);
                }, function(error) {
                    console.error(error);
                    window.document.getElementById('splash').innerHTML = "Something went wrong&hellip;<br/><br/>Try reloading the page&hellip;";
                });
            }, function(error) {
                console.error(error);
                window.document.getElementById('splash').innerHTML = "Something went wrong&hellip;<br/><br/>Try reloading the page&hellip;";
            });


        });
}, false);
